<script>
import TwButton from '@/components/generic/tw-button.vue'
import { UserPlusIcon } from '@heroicons/vue/24/outline'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserTeamSocialsShare from '@/components/fundraisers/fundraiser-team-socials-share.vue'
import FundraiserSubscribeToUpdatesModal from '@/components/fundraiser-updates/fundraiser-subscribe-to-updates-modal.vue'
import loggedInUserMixin from '../../../../mixins/loggedInUserMixin.js'
import TwSelect from '../../../generic/forms/tw-select.vue'
import FundraiserTeamJoinModal from '../../../fundraiser-pages/fundraiser-team-join-modal.vue'

export default {
  name: 'TeamActions',
  components: { FundraiserTeamJoinModal, TwSelect, FundraiserSubscribeToUpdatesModal, FundraiserTeamSocialsShare, TwModal, TwButton, UserPlusIcon },
  mixins:[loggedInUserMixin],
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      required: true
    }
  },
  methods: {
    joinTeam() {
      if(this.loggedInUser) {
        this.$refs.joinTeamModal.open()
      }
      else
        this.$router.push({ name: 'FundraiserTeamPublicJoinPage', params: { fundraiserId: this.fundraiser.id, teamId: this.team.id } })
    }
  }
}
</script>

<template>
  <div class="flex flex-col gap-3">
    <tw-button :to="{ name: 'TeamDonatePage', params: { teamId: team.id } }" block size="lg" class="mt-5" variant="amber">
      Donate
    </tw-button>
    <tw-button v-if="fundraiser.settings && fundraiser.settings.enable_supporters" block variant="secondary" size="lg" @click="joinTeam">
      Join this Team
    </tw-button>
    <div class="flex gap-3">
      <tw-button block variant="outline" class="text-md" @click="$refs.shareModal.open()">
        Share
      </tw-button>
      <tw-button block variant="outline" class="text-md" @click="$refs.subscribeToTeamFundraiserModal.open()">
        Subscribe
      </tw-button>
    </div>
    <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this team fundraiser" @ok="$refs.shareModal.close()">
      <fundraiser-team-socials-share :fundraiser="fundraiser" :team="team" />
    </tw-modal>
    <fundraiser-subscribe-to-updates-modal ref="subscribeToTeamFundraiserModal" :subscribable="fundraiser" />
    <fundraiser-team-join-modal ref="joinTeamModal" :fundraiser="fundraiser" :team="team" />
  </div>
</template>

<style scoped>

</style>
